function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function Calendar({
  width = 20,
  height = 22,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M2.835 8.62h16.339M15.072 12.2h.008M11.004 12.2h.009M6.928 12.2h.009M15.072 15.763h.008M11.004 15.763h.009M6.928 15.763h.009M14.707 1.833V4.85M7.302 1.833V4.85",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M14.885 3.28H7.123c-2.692 0-4.373 1.5-4.373 4.257v8.295c0 2.8 1.681 4.334 4.373 4.334h7.754c2.7 0 4.373-1.508 4.373-4.264V7.537c.009-2.757-1.665-4.256-4.365-4.256z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
//# sourceMappingURL=Calendar.js.map